import React from "react";
import { useParams } from "react-router-dom";
import GoalsList from "@/components/goals/GoalsList";
import GoalComposer from "@/components/goals/GoalComposer";
import GoalView from "@/components/goals/GoalView";

export default function GoalsPage() {
    const { id } = useParams();
    const isEdit = typeof window !== "undefined" && window.location.pathname.endsWith("/edit");
    if (id === "new") return <GoalComposer />;
    if (id && isEdit) return <GoalComposer editingId={id} />;
    if (id) return <GoalView id={id} />;
    return <GoalsList />;
}
